import transact from 'src/lib/data/transact'

import dbSlice from 'src/store/db/slice'
import * as networkSelectors from 'src/store/selectors/network'
/** @public to be deprecated */
export const optInFeature =
  ({ feature }) =>
  async (dispatch, getState) => {
    const state = getState()
    const networkId = networkSelectors.idSelector(state)
    await transact([
      [
        '@network/opt-in-feature',
        {
          networkId,
          feature
        }
      ]
    ])
    dispatch(dbSlice.actions.optInFeature({ feature, networkId }))
  }
/** @public to be deprecated */
export const inheritFeature =
  ({ feature }) =>
  async (dispatch, getState) => {
    const state = getState()
    const networkId = networkSelectors.idSelector(state)
    await transact([
      [
        '@network/inherit-feature',
        {
          networkId,
          feature
        }
      ]
    ])
    dispatch(dbSlice.actions.inheritFeature({ feature, networkId }))
  }
/** @public to be deprecated */
export const optOutFeature =
  ({ feature }) =>
  async (dispatch, getState) => {
    const state = getState()
    const networkId = networkSelectors.idSelector(state)
    await transact([
      [
        '@network/opt-out-feature',
        {
          networkId,
          feature
        }
      ]
    ])
    dispatch(dbSlice.actions.optOutFeature({ feature, networkId }))
  }
